import { createFileRoute } from '@tanstack/react-router';

import { TranslationCreate } from '@/module/Author/Translation/TranslationCreate';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <TranslationCreate />;
}
